import { useAuth } from '@auth/use-auth'
import LockIcon from '@mui/icons-material/Lock'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { isInIframe } from '@utils/is-in-iframe'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const SessionExpired = () => {
  const navigate = useNavigate()
  const { initialized, userName } = useAuth()

  useEffect(() => {
    if (initialized && userName) {
      navigate('/')
    }
  }, [initialized, userName, navigate])

  const safeReload = () => {
    try {
      if (isInIframe) {
        void window.top?.location?.toString()
        window.top.location.reload()
      } else {
        window.location.reload()
      }
    } catch (e) {
      console.error('Parent reload failed, fallback to self reload:', e)
      window.location.reload()
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <LockIcon fontSize="large" color="primary" />
      <Typography variant="h5" gutterBottom>
        Session expired
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: 400 }}>
        Your session is no longer valid. Please refresh the page to continue.
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          mt: 3,
        }}
      >
        <Button variant="contained" onClick={safeReload}>
          Refresh Page
        </Button>
      </Stack>
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{
          mt: 2,
        }}
      >
        If the issue persists, please contact support.
      </Typography>
    </Box>
  )
}
